import React, { useState, useEffect } from 'react';
import { apiFetch } from '../api';

export default function CourseSelector({ onSelect, onDegreeChange }) {
    const [degree, setDegree] = useState('');
    const [semester, setSemester] = useState('');
    const [courses, setCourses] = useState([]);
  
    useEffect(() => {
      if (!degree || !semester) return;
  
      apiFetch(`get_courses.php?degree=${degree}&semester=${semester}`)
      .then(res => res.json())
      .then(data => setCourses(data))
      .catch(console.error);
  }, [degree, semester]);

  
    const handleDegreeChange = (e) => {
      const value = e.target.value;
      setDegree(value);
      if (onDegreeChange) onDegreeChange(value); // 🔁 wichtig!
    };
  
    return (
      <div className="course-selector">
        <label>Studiengang:</label>
        <select value={degree} onChange={handleDegreeChange}>
          <option value="">-- Wählen --</option>
          <option value="Bachelor">Bachelor</option>
          <option value="Master">Master</option>
        </select>
  
        <label>Semester:</label>
        <select value={semester} onChange={(e) => setSemester(e.target.value)}>
          <option value="">-- Wählen --</option>
          {[1,2,3,4,5,6].map(s => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
  
        <label>Kurs:</label>
        <select onChange={(e) => onSelect(e.target.value)} disabled={!courses.length}>
          <option value="">-- Kurs wählen --</option>
          {courses.map((title, i) => (
            <option key={i} value={title}>{title}</option>
          ))}
        </select>
      </div>
    );
  }
  